import { decodeAccountMutationAuthorizationV1 } from "./account-state-session-repository.js";

function fields(value, names) {
  if (!value || typeof value !== "object" || Array.isArray(value)
      || Object.keys(value).sort().join(",") !== [...names].sort().join(",")) {
    throw new TypeError("Unsupported participation response fields.");
  }
}
function text(value, max = 4096) {
  return typeof value === "string" && value.length > 0 && value.length <= max;
}
function nullable(value, check) { return value === null || check(value); }
function integer(value) { return Number.isSafeInteger(value) && value >= 0; }

export function decodeTrackerParticipationRegistrationV1(value) {
  fields(value, ["registrationId", "journalId", "revision", "state", "noticeVersion", "locale", "preview", "authorizedAtUnixMs", "disabledAtUnixMs", "revocation"]);
  if (!/^trk_[0-9a-f]{32}$/.test(value.registrationId) || !text(value.journalId, 128)
      || !integer(value.revision) || !["reviewRequired", "authorized", "disabled"].includes(value.state)
      || !nullable(value.noticeVersion, item => text(item, 128))
      || !nullable(value.locale, item => ["en-US", "de-DE"].includes(item))
      || !nullable(value.authorizedAtUnixMs, integer) || !nullable(value.disabledAtUnixMs, integer)
      || !["notRequired", "pending", "completed"].includes(value.revocation)) {
    throw new TypeError("Invalid participation registration.");
  }
  if (value.preview !== null) {
    const preview = value.preview;
    fields(preview, ["factCount", "firstSourceObservedAtNs", "lastSourceObservedAtNs", "factKinds", "containsIdentityNames", "hasGaps"]);
    const timestamp = item => typeof item === "string" && /^[0-9]{1,20}$/.test(item);
    if (!integer(preview.factCount) || !nullable(preview.firstSourceObservedAtNs, timestamp)
        || !nullable(preview.lastSourceObservedAtNs, timestamp)
        || !Array.isArray(preview.factKinds) || preview.factKinds.length > 64
        || !preview.factKinds.every(item => text(item, 128))
        || typeof preview.containsIdentityNames !== "boolean" || typeof preview.hasGaps !== "boolean") {
      throw new TypeError("Invalid retained-history preview.");
    }
  }
  return value;
}

export function decodeTrackerParticipationResponseV1(value) {
  fields(value, ["schemaVersion", "accountId", "mutationAuthorization", "noticeVersion", "canAuthorize", "disclosure", "registrations"]);
  if (value.schemaVersion !== 1 || !/^acc_[0-9a-f]{32}$/.test(value.accountId)
      || typeof value.canAuthorize !== "boolean" || (value.canAuthorize && value.disclosure === null)
      || !text(value.noticeVersion, 128) || !Array.isArray(value.registrations) || value.registrations.length > 16) {
    throw new TypeError("Unsupported participation response.");
  }
  decodeAccountMutationAuthorizationV1(value.mutationAuthorization);
  if (value.disclosure !== null) {
    fields(value.disclosure, ["en-US", "de-DE"]);
    for (const disclosure of Object.values(value.disclosure)) {
      fields(disclosure, ["title", "paragraphs"]);
      if (!text(disclosure.title, 160) || !Array.isArray(disclosure.paragraphs)
          || disclosure.paragraphs.length < 1 || disclosure.paragraphs.length > 16
          || !disclosure.paragraphs.every(item => text(item, 2048))) {
        throw new TypeError("Unsupported participation disclosure.");
      }
    }
  }
  value.registrations.forEach(decodeTrackerParticipationRegistrationV1);
  if (new Set(value.registrations.map(item => item.registrationId)).size !== value.registrations.length) {
    throw new TypeError("Duplicate participation registration.");
  }
  return value;
}
